<template>
  <footer class="bg-[#131112] pt-[0px] pb-[40px]">
    <!-- 波浪 -->
    <img class="w-full bg-[#FACCDB] mb-[-2px]" src="@/assets/imgs/bl3.png" alt="decor" />

    <div class="max-w-7xl mx-auto [@media(max-width:1280px)]:px-[60px] mt-[20px]">
      <!-- 主要内容区域 -->
      <div class="bg-[#131112] grid gap-2 grid-cols-1 pt-[5px] lg:grid-cols-[50%_1fr] mb-[15px]">
        <div class="text-center lg:text-left">
          <div class="flex items-center justify-center lg:justify-start gap-[16px]">
            <img class="w-[16px] h-[16px]" src="@/assets/imgs/logo.png" alt="KJV Bible logo" />
            <span class="text-[18px] text-[#ffffff] font-semibold">Women's Bible</span>
          </div>
          <h3 class="text-[16px] text-[#ffffff] mt-[16px] font-semibold [@media(max-width:750px)]:text-center">Contact us</h3>
          <p class="text-[16px] text-[#ffffff] mt-[8px] [@media(max-width:750px)]:text-center">joyssk2708@gmail.com</p>
        </div>
        <div class="flex gap-[16px] justify-between flex-col lg:flex-row items-center lg:items-start">
          <div class="nav-link" @click="scrollTo('home')">Home</div>
          <div class="nav-link" @click="scrollTo('function')">Function</div>
          <div class="nav-link" @click="scrollTo('values')">Values</div>
          <div class="nav-link" @click="scrollTo('features')">Features</div>
          <div class="nav-link" @click="scrollTo('faq')">FAQ</div>
        </div>
      </div>
      <!-- 分割线 -->
      <div class="bg-[#131112]">
        <div class="footer-separator"></div>
        <div class="flex justify-between flex-col [@media(min-width:750px)]:flex-row items-center">
          <div class="text-[16px] text-[#ffffff]">
            <span>© 2024 Artix. All Rights Reserved</span>
          </div>
          <div class="flex text-[16px]">
            <span class="nav-link mr-[16px]" @click="handleOpen('./privacy.html')">Privacy Policy</span>
            <span class="nav-link text-[#ffffff]" @click="handleOpen('./terms.html')">Terms & Conditions</span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
const prefix = import.meta.env.MODE === 'production' ? '/womenbible/' : './'
function handleOpen(path: string) {
  window.open(`${prefix}${path}`)
}

const props = defineProps({
  currentPage: {
    default: 'home',
  },
})
const emit = defineEmits(['update:page'])

function scrollTo(value: string) {
  emit('update:page', value)
}
</script>

<style scoped lang="less">
.nav-link {
  color: #bbb7b7;
  text-decoration: none;
  font-size: 16px;
  transition: color 0.3s ease;
  cursor: pointer;
  &:hover {
    color: #ffffff;
  }
}

.footer-separator {
  height: 1px;
  background-color: #333333;
  margin-bottom: 15px;
}
</style>
